const ensure = (arg) => {
  if (arg === undefined || arg === null) {
    return {};
  }
  return arg;
};
export default ensure;
